import React, { ReactNode } from 'react';
import cx from 'classnames';
import styles from './index.scss';

interface ListWidgetProps<T = any> {
  className?: string;
  header: ReactNode;
  items?: T[];
  renderItem?: (item: T, index: number) => void;
}

export const ListWidget = <T,>({
  className,
  header,
  items = [],
  renderItem,
}: ListWidgetProps<T>) => {
  return (
    <section className={cx(styles.ListWidget, className)}>
      <div>{header}</div>
      <div>{items.map((item, index) => renderItem?.(item, index))}</div>
    </section>
  );
};
